function woDashboardReducer(state = [], action) {
    const { type, payload } = action;
    let work_orders = [];

    switch(type) {
        case "GET_WORK_ORDERS_SUCCESS":
            work_orders = [];
            if(payload.page != 0)
                work_orders = Object.assign([], state.work_orders);
                
            if(payload.search)
                work_orders = work_orders.concat(payload.response.docs);
            else
                work_orders = work_orders.concat(payload.workorders);
            return Object.assign({}, state, { work_orders, search: payload.search });

        case "REMOVE_TRIAGE":
            work_orders = Object.assign([], state.work_orders);
            work_orders[payload.index].in_triage = 0;
            work_orders[payload.index].disposition = "WS";
            if(payload.wo_type != 1)
                work_orders[payload.index].repair_type = 2;
            return Object.assign({}, state, { work_orders });

        case "SEARCH_EQUIPMENT_SUCCESS":
            let equipment = payload.response.docs.map((e, i) => {
                return {
                    key: `equip_${i}`,
                    title: e[`EMEQP`],
                    description: e[`ECDESC`],
                    value: e[`EMEQP`]
                }
            });
            return Object.assign({}, state, { equipment });

        case "SET_WORK_ORDERS":
            return Object.assign({}, state, { ...payload });

        case "SET_FILTER":
            return Object.assign({}, state, { ...payload });

        default:
            return state;
    }
}

export default woDashboardReducer;